module.exports = __webpack_public_path__ + "static/media/dp.1a03fde7.png";